import { Box, Button, Link, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

const FIDELITY_CHECKLIST_URL = 'https://start.org/peer-to-peer-fidelity-checklist'

interface Props {
  onBack: () => void
}

export const SubmissionSummary = ({ onBack }: Props): JSX.Element => (
  <Box data-testid='p2pSubmissionSummary' sx={{ textAlign: 'center', py: '24px' }}>
    <CheckCircleIcon sx={{ color: 'success.main', fontSize: '48px', mb: '8px' }} />
    <Typography variant='h3' sx={{ mb: '8px' }}>Report submitted</Typography>
    <Typography variant='body1' sx={{ mb: '16px' }}>
      Thank you! Your Peer to Peer report has been sent to the START team, and a confirmation email is on its way.
      Your report is now read-only.
    </Typography>
    <Box sx={{ mb: '20px' }}>
      <Link href={FIDELITY_CHECKLIST_URL} target='_blank' rel='noopener noreferrer' data-testid='p2pFidelityChecklistLink'>
        Peer to Peer program fidelity checklist
      </Link>
    </Box>
    <Button variant='contained' color='primary' onClick={onBack} data-testid='p2pSummaryBackToOverview'>Back to Overview</Button>
  </Box>
)
